// The picture of a circle with its centre, and any of a line from the
// centre to the circle, a line across it and a label on its edge. Plain
// React SVG, like practice-graphs.tsx.

import {
  CIRCLE_LABEL_SIZE,
  circlePartsPicture,
  describeCircleParts,
  type CirclePartsSpec,
} from './practice-circle-data';

const INK = '#2d4a3e';
const FILL = '#eef3ee';

const fixed = (value: number) => value.toFixed(2);

export function CirclePartsView({ circle }: { circle: CirclePartsSpec }) {
  const picture = circlePartsPicture(circle);
  const { box } = picture;

  return (
    <figure className="m-0 max-w-md">
      <svg
        role="img"
        aria-label={describeCircleParts(circle)}
        viewBox={`${fixed(box.x)} ${fixed(box.y)} ${fixed(box.width)} ${fixed(box.height)}`}
        className="mx-auto block h-auto w-full"
        style={{ maxWidth: `${String(Math.round(box.width * 1.4))}px` }}
      >
        <circle
          data-part="circle"
          cx="0"
          cy="0"
          r={fixed(picture.radius)}
          fill={FILL}
          stroke={INK}
          strokeWidth="2.2"
        />
        {picture.lines.map((line) => (
          <line
            key={line.part}
            data-part={line.part}
            x1={fixed(line.from.x)}
            y1={fixed(line.from.y)}
            x2={fixed(line.to.x)}
            y2={fixed(line.to.y)}
            stroke={INK}
            strokeWidth="2"
            strokeLinecap="round"
          />
        ))}
        {picture.dots.map((dot, index) => (
          <circle
            key={index}
            data-part={index === 0 ? 'centre' : 'point'}
            cx={fixed(dot.x)}
            cy={fixed(dot.y)}
            r={index === 0 ? '3.2' : '2.6'}
            fill={INK}
          />
        ))}
        {picture.texts.map((text, index) => (
          <text
            key={index}
            data-label={text.part}
            x={fixed(text.x)}
            y={fixed(text.y)}
            dy="0.35em"
            textAnchor="middle"
            fill={INK}
            fontSize={CIRCLE_LABEL_SIZE}
            fontWeight="700"
            stroke="#ffffff"
            strokeWidth="3"
            paintOrder="stroke"
          >
            {text.text}
          </text>
        ))}
      </svg>
    </figure>
  );
}
